import { desktopMainColumnInsetSx } from "../../layout/layoutMetrics";


export const managementPageShellSx = {
  root: {
    flex: 1,
    minHeight: 0,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  modeButtonsWrap: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    flexShrink: 0,
    pl: { xs: 1.5, md: 0 },
    pr: { xs: 1.5, md: 0 },

    ...desktopMainColumnInsetSx,

  },
  contentWrap: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "stretch",
    overflow: "hidden",
    pt: { xs: 2, md: 4 },
    pb: 0,
    pl: { xs: 1.5, sm: 2, md: 3 },
    pr: { xs: 1.5, sm: 2, md: 3 },

    ...desktopMainColumnInsetSx,

  },
  paper: {
    width: "100%",
    maxWidth: 1050,
    flex: 1,
    height: "100%",
    p: { xs: 1.5, sm: 2 },
    borderRadius: 2,
    background: "transparent",
    backdropFilter: "blur(6px)",
    border: "1px solid rgba(255,255,255,0.18)",
    color: "white",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    mb: 1.5,
    flexShrink: 0,
  },
  headerCloseButton: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  headerIcon: {
    mr: 1,
    color: "white",
    fontSize: { xs: 20, sm: 22 },
  },
  headerTitle: {
    fontWeight: 600,
    fontSize: { xs: 16, sm: 18 },
  },
  tabs: {
    mb: 1.5,
    flexShrink: 0,
    minHeight: { xs: 40, sm: 36 },
    "& .MuiTab-root": {
      color: "white",
      fontSize: { xs: 11, sm: 12 },
      minHeight: { xs: 40, sm: 36 },
      px: { xs: 0.5, sm: 1 },
    },
  },
  tabIcon: {
    fontSize: { xs: 14, sm: 16 },
  },
  scrollContent: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflowY: "auto",
    overflowX: "hidden",
    pr: { xs: 0, sm: 0.5 },
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(255,255,255,0.3)",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "rgba(255,255,255,0.5)",
    },
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(255,255,255,0.3) transparent",
  },
};

export const pageCloseButtonSx = {
  width: 34,
  height: 34,
  borderRadius: "8px",
  border: "1px solid rgba(255,255,255,0.18)",
  color: "rgba(255,255,255,0.5)",
  flexShrink: 0,
  "&:hover": { color: "#fff", background: "rgba(255,255,255,0.06)" },
};
